var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterregEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "173.89mm",
    height: "56.64mm",
    viewBox: "0 0 492.93 160.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "interreg_en") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.06,
    width: 492.93,
    height: 160.54,
    fill: "none",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M128.42,114.8v3.43H114.91V95.77h3.78v19Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.06,116.15a7,7,0,0,1-5.65,2.24c-3.69,0-6-2.28-6-5.29s2.34-5.1,6.45-5.14H142v-.51c0-2.15-1.38-3.43-4.07-3.43a9,9,0,0,0-5,1.73l-1.51-2.57a12.54,12.54,0,0,1,7.35-2.15c4.4,0,6.87,2.25,6.9,6l0,11.2h-3.62Zm0-3.92v-1.57H137.4c-2.4,0-3.53.64-3.53,2.28s1.25,2.53,3.31,2.53C139.81,115.47,141.83,114.09,142,112.23Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.28,117.14a8.19,8.19,0,0,1-4.2,1.25c-2.57,0-4.78-1.47-4.78-5v-8.86h-2.41V101.8h2.41V97.12H155v4.68h5v2.76h-5v8.19c0,1.76.67,2.31,1.83,2.31a5.94,5.94,0,0,0,2.56-.74Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.6,118.23,161,101.16h3.85l4.75,13.45,4.68-13.45H178l-6.54,17.07Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51,96.28A2.15,2.15,0,1,1,182.36,94,2.13,2.13,0,0,1,184.51,96.28Zm-4,22V101.16h3.66v17.07Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.27,118.71c0,4.05-2.79,5.91-5.52,5.91a6,6,0,0,1-3.56-1.16l1.22-2.85a3.93,3.93,0,0,0,2.18.77c1.12,0,2-.68,2-2.31V101.16h3.66Zm.45-22.43A2.26,2.26,0,1,1,191.44,94,2.18,2.18,0,0,1,193.72,96.28Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.09,116.15a7,7,0,0,1-5.65,2.24c-3.69,0-6-2.28-6-5.29s2.35-5.1,6.45-5.14h5.17v-.51c0-2.15-1.38-3.43-4.08-3.43a9,9,0,0,0-5,1.73l-1.51-2.57a12.51,12.51,0,0,1,7.35-2.15c4.39,0,6.86,2.25,6.9,6l0,11.2h-3.63Zm0-3.92v-1.57h-4.62c-2.41,0-3.53.64-3.53,2.28s1.25,2.53,3.3,2.53C206.85,115.47,208.87,114.09,209.06,112.23Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.82,111v-2.53h12.35V111Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.37,114.8v3.43H235.86V95.77h3.79v19Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.75,96.28A2.15,2.15,0,1,1,254.6,94,2.13,2.13,0,0,1,256.75,96.28Zm-4,22V101.16h3.66v17.07Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.91,111.11H264a5.19,5.19,0,0,0,5.29,4.27,6.64,6.64,0,0,0,4.81-2l2,2.08a9.29,9.29,0,0,1-7.06,2.89c-5.26,0-8.73-3.5-8.73-8.63a8.29,8.29,0,0,1,8.63-8.7C274.92,101,277.35,105,276.91,111.11Zm-3.21-2.7A4.39,4.39,0,0,0,269,104a4.87,4.87,0,0,0-5,4.43Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.42,117.14a8.23,8.23,0,0,1-4.21,1.25c-2.57,0-4.78-1.47-4.78-5v-8.86H279V101.8h2.41V97.12h3.66v4.68h5v2.76h-5v8.19c0,1.76.67,2.31,1.83,2.31a6,6,0,0,0,2.57-.74Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.32,118.23h-3.69v-3.34c-1.16,2.38-3.31,3.44-6.1,3.47-3.92,0-6.26-2.5-6.26-6.58V101.16H297v9.6c0,2.56,1.51,4.13,4,4.13,2.95-.06,4.69-2.34,4.69-5.32v-8.41h3.69Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.69,118.23l-6.61-17.07h3.85l4.75,13.45,4.68-13.45h3.69l-6.54,17.07Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.86,116.15a7,7,0,0,1-5.65,2.24c-3.69,0-6-2.28-6-5.29s2.34-5.1,6.45-5.14h5.16v-.51c0-2.15-1.38-3.43-4.07-3.43a9,9,0,0,0-5,1.73l-1.51-2.57a12.54,12.54,0,0,1,7.35-2.15c4.4,0,6.87,2.25,6.9,6l0,11.2h-3.62Zm0-3.92v-1.57H337.2c-2.4,0-3.53.64-3.53,2.28s1.25,2.53,3.31,2.53C339.61,115.47,341.63,114.09,341.82,112.23Z",
    fill: "#164194"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M124.81,33.82H114.9V64.24c3.22-.61,6.53-1.19,9.91-1.76Z",
    fill: "#a3add8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.33,52.72h8.11V44.36h-8.11v-8.8h-9.77v8.8h-4.11v8.36h4.11v3.79c3.22-.25,6.48-.49,9.77-.7Z",
    fill: "#a3add8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,51.56a6.62,6.62,0,0,1,5.53,2.72q4.88-.11,9.8-.16c-2.27-6-7.26-10.4-15.33-10.4A16.63,16.63,0,0,0,200.12,55q5-.23,10.08-.4a6.78,6.78,0,0,1,5.81-3",
    fill: "#a3add8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.49,54.24a13.25,13.25,0,0,1,2.82-.3h.51V43.72c-5.78-.26-9,2.83-11,7.59v-7h-9.77v9.72h.53q8.52,0,16.9.16",
    fill: "#a3add8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.19,53.94h.51V43.72c-5.78-.26-9,2.83-11,7.59v-7h-9.78v10.1q7.63.23,15.09.58a11.51,11.51,0,0,1,5.17-1.1",
    fill: "#a3add8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.86,51.56c3.61,0,6,2.29,7,5.81,3.19.29,6.35.61,9.47.94-1.31-8-6.58-14.59-16.44-14.59a16.65,16.65,0,0,0-16.09,11.9q4.74.29,9.4.63a7,7,0,0,1,6.69-4.69",
    fill: "#a3add8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.85,59.92v-.13c0-4.69,3.6-8,8.36-8s8.42,3.28,8.42,8v.13a8,8,0,0,1-.39,2.54q5.14.85,10,1.78V44.36H356.5v4.5c-2.63-2.89-5.78-5.14-11.12-5.14-7.66,0-14.81,5.44-15.26,15.13q5,.55,9.74,1.19s0-.08,0-.12",
    fill: "#a3add8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.36,52.79a6.66,6.66,0,0,1,5.57,0,6.43,6.43,0,0,1,3.93,5.42q4.65-.49,9.42-.92a16.69,16.69,0,0,0-8.74-11.6,14.86,14.86,0,0,0-14.79,0c-5.78,2.93-9,8.78-9.19,15.43,3.19-.47,6.45-.91,9.76-1.34,0-3.33,1.05-5.57,4-7",
    fill: "#a3add8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.81,78.82V62.49c-3.38.56-6.69,1.14-9.91,1.75V78.82Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.59,79.4a14.44,14.44,0,0,0,7.72-2V69.57a10,10,0,0,1-4.83,1.22c-2.18,0-3.15-1.1-3.15-3.35V55.81c-3.29.21-6.55.45-9.77.7V69.05c0,8,4.05,10.35,10,10.35",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,61.79c0,10.54,7.65,17.8,18,17.8,6.24,0,10.87-2.44,14.08-6.43l-5.59-5c-2.7,2.51-5.08,3.54-8.36,3.54-4.37,0-7.46-2.31-8.43-6.75h24c.06-.9.13-1.8.13-2.57a23.5,23.5,0,0,0-1.45-8.31q-4.92.06-9.81.16a9.78,9.78,0,0,1,1.74,4.61H208.55a10.83,10.83,0,0,1,1.65-4.3c-3.38.12-6.74.25-10.08.41A19.7,19.7,0,0,0,199,61.66Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83,78.82V66.09c0-7,2.85-10.82,7.66-11.85q-8.38-.16-16.9-.16h-.53V78.82Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.71,78.82V66.09c0-5.73,1.94-9.37,5.31-11.05q-7.45-.36-15.09-.58V78.82Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.82,61.79c0,10.54,7.65,17.8,18,17.8,6.24,0,10.87-2.44,14.09-6.43l-5.6-5c-2.7,2.51-5.08,3.54-8.36,3.54-4.37,0-7.46-2.31-8.42-6.75h24c.07-.9.13-1.8.13-2.57a25.45,25.45,0,0,0-.34-4.12c-3.12-.33-6.28-.65-9.47-.94a14.11,14.11,0,0,1,.29,1.52H301.4a12.41,12.41,0,0,1,.77-2.65q-4.67-.33-9.4-.62a19.64,19.64,0,0,0-.95,6Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.08,59.92c0,10.22,7.27,16.07,15.3,16.07,5.21,0,8.36-2.12,11.25-5.59v1.67c0,6.17-3.15,9.39-9.83,9.39a22.5,22.5,0,0,1-11.64-3.15l-3.34,7.33a32.73,32.73,0,0,0,15.23,3.6c6.69,0,11.64-1.42,14.86-4.63,2.89-2.89,4.37-7.39,4.37-13.57v-6.8q-4.89-.93-10-1.78a8.1,8.1,0,0,1-8,5.43c-4.72,0-8.29-3.16-8.35-7.85q-4.78-.63-9.74-1.19c0,.31,0,.62,0,.94Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,59.87V78.81h9.77V61.65a20.8,20.8,0,0,0-.47-4.36q-4.77.42-9.42.92a12.34,12.34,0,0,1,.12,1.66",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.54,61.77v17h9.78v-19c-3.31.43-6.57.87-9.76,1.34,0,.18,0,.35,0,.53Z",
    fill: "#164194"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.81,130.47V132h2.69v.83h-2.69v1.51h3.09v.84h-4v-5.49h3.92v.83Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.56,135.13h-.9v-.82a1.54,1.54,0,0,1-1.49.85,1.45,1.45,0,0,1-1.53-1.61V131h.9v2.35a.91.91,0,0,0,1,1,1.18,1.18,0,0,0,1.15-1.3V131h.9Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.59,131.78a1.52,1.52,0,0,1,1.44-.86v.86a1.27,1.27,0,0,0-1.44,1.17v2.18h-.9V131h.9Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.54,133a2.18,2.18,0,1,1-2.18-2.12A2.05,2.05,0,0,1,131.54,133Zm-3.46,0a1.28,1.28,0,1,0,1.28-1.35A1.25,1.25,0,0,0,128.08,133.05Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.66,133.06a1.93,1.93,0,0,1-2,2.1,1.65,1.65,0,0,1-1.48-.76v2.25h-.9V131h.9v.72a1.65,1.65,0,0,1,1.46-.75A2,2,0,0,1,136.66,133.06Zm-.91,0a1.27,1.27,0,1,0-1.27,1.37A1.27,1.27,0,0,0,135.75,133Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.07,133.38h-3.15a1.26,1.26,0,0,0,1.29,1.05,1.61,1.61,0,0,0,1.18-.49l.48.51a2.28,2.28,0,0,1-1.73.71,2,2,0,0,1-2.13-2.11,2,2,0,0,1,2.11-2.13C140.58,130.92,141.18,131.88,141.07,133.38Zm-.78-.65a1.08,1.08,0,0,0-1.17-1.09,1.19,1.19,0,0,0-1.22,1.09Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.31,134.62a1.72,1.72,0,0,1-1.38.54,1.32,1.32,0,0,1-1.47-1.29c0-.76.57-1.25,1.58-1.25h1.26v-.13c0-.52-.34-.84-1-.84a2.16,2.16,0,0,0-1.23.43l-.37-.63a3,3,0,0,1,1.8-.53c1.07,0,1.68.55,1.69,1.47v2.74h-.88Zm0-1v-.39h-1.13c-.59,0-.86.16-.86.56s.3.62.81.62S144.25,134.11,144.3,133.66Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.19,132.53v2.6h-.9v-2.35a.93.93,0,0,0-1-1,1.17,1.17,0,0,0-1.18,1.14v2.22h-.9V131h.9v.8a1.58,1.58,0,0,1,1.54-.83A1.46,1.46,0,0,1,150.19,132.53Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.54,133.46H154v1.66h-.93v-5.49h2.23c1.41,0,2.21.68,2.21,1.87a1.75,1.75,0,0,1-1.13,1.78l1.23,1.84h-1Zm-.25-.82c.85,0,1.34-.36,1.34-1.11s-.49-1.06-1.34-1.06H154v2.17Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.15,133.38H159a1.27,1.27,0,0,0,1.3,1.05,1.59,1.59,0,0,0,1.17-.49l.48.51a2.26,2.26,0,0,1-1.72.71,2.12,2.12,0,1,1,0-4.24C161.66,130.92,162.26,131.88,162.15,133.38Zm-.79-.65a1.07,1.07,0,0,0-1.16-1.09,1.19,1.19,0,0,0-1.22,1.09Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.65,134.72a1.93,1.93,0,0,1-2.17,1.95,3,3,0,0,1-1.73-.55l.38-.65a2.11,2.11,0,0,0,1.31.46,1.18,1.18,0,0,0,1.31-1.19v-.52a1.53,1.53,0,0,1-1.38.7,2,2,0,0,1,0-4,1.54,1.54,0,0,1,1.41.71V131h.9Zm-.9-1.79a1.21,1.21,0,1,0-1.2,1.29A1.19,1.19,0,0,0,165.75,132.93Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.67,129.76a.52.52,0,0,1-.53.54.51.51,0,0,1-.52-.54.52.52,0,0,1,.52-.55A.53.53,0,0,1,168.67,129.76Zm-1,5.37V131h.89v4.18Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.68,133a2.18,2.18,0,1,1-2.17-2.12A2.05,2.05,0,0,1,173.68,133Zm-3.45,0a1.28,1.28,0,1,0,1.28-1.35A1.25,1.25,0,0,0,170.23,133.05Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.41,132.53v2.6h-.9v-2.35a.93.93,0,0,0-1-1,1.17,1.17,0,0,0-1.18,1.14v2.22h-.91V131h.91v.8a1.57,1.57,0,0,1,1.53-.83A1.46,1.46,0,0,1,178.41,132.53Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,134.62a1.72,1.72,0,0,1-1.38.54,1.32,1.32,0,0,1-1.47-1.29c0-.76.58-1.25,1.58-1.25h1.26v-.13c0-.52-.33-.84-1-.84a2.14,2.14,0,0,0-1.23.43l-.37-.63a3,3,0,0,1,1.79-.53c1.08,0,1.68.55,1.69,1.47v2.74h-.89Zm0-1v-.39h-1.13c-.58,0-.86.16-.86.56s.31.62.81.62S181.86,134.11,181.9,133.66Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.84,135.13v-5.82h.9v5.82Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,129.64a2.75,2.75,0,1,1,0,5.49h-2.23v-5.49Zm-1.32,4.65h1.35a1.84,1.84,0,0,0,1.88-1.9,1.87,1.87,0,0,0-1.92-1.92h-1.31Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.27,133.38h-3.15a1.26,1.26,0,0,0,1.29,1.05,1.61,1.61,0,0,0,1.18-.49l.48.51a2.28,2.28,0,0,1-1.73.71,2.12,2.12,0,0,1,0-4.24C196.79,130.92,197.38,131.88,197.27,133.38Zm-.78-.65a1.07,1.07,0,0,0-1.16-1.09,1.2,1.2,0,0,0-1.23,1.09Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,135.13,197.35,131h.94l1.16,3.29L200.6,131h.9l-1.6,4.18Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.59,133.38h-3.15a1.26,1.26,0,0,0,1.29,1.05,1.61,1.61,0,0,0,1.18-.49l.48.51a2.28,2.28,0,0,1-1.73.71,2,2,0,0,1-2.13-2.11,2,2,0,0,1,2.11-2.13C205.1,130.92,205.7,131.88,205.59,133.38Zm-.78-.65a1.08,1.08,0,0,0-1.16-1.09,1.2,1.2,0,0,0-1.23,1.09Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.37,135.13v-5.82h.9v5.82Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.4,133a2.18,2.18,0,1,1-2.18-2.12A2.05,2.05,0,0,1,212.4,133Zm-3.45,0a1.27,1.27,0,1,0,1.27-1.35A1.25,1.25,0,0,0,209,133.05Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.52,133.06a1.93,1.93,0,0,1-2,2.1,1.65,1.65,0,0,1-1.48-.76v2.25h-.9V131h.9v.72a1.65,1.65,0,0,1,1.46-.75A2,2,0,0,1,217.52,133.06Zm-.91,0a1.27,1.27,0,1,0-1.27,1.37A1.27,1.27,0,0,0,216.61,133Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.23,132.53v2.6h-.9v-2.35a.93.93,0,0,0-1-1,1.18,1.18,0,0,0-1.14,1.3v2.07h-.91v-2.35a.92.92,0,0,0-1-1,1.19,1.19,0,0,0-1.16,1.3v2.07h-.89V131h.89v.81a1.55,1.55,0,0,1,1.52-.84,1.4,1.4,0,0,1,1.45,1,1.53,1.53,0,0,1,1.58-1A1.45,1.45,0,0,1,225.23,132.53Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.9,133.38h-3.15a1.27,1.27,0,0,0,1.3,1.05,1.59,1.59,0,0,0,1.17-.49l.48.51a2.26,2.26,0,0,1-1.73.71,2.12,2.12,0,0,1,0-4.24C229.42,130.92,230,131.88,229.9,133.38Zm-.78-.65a1.07,1.07,0,0,0-1.16-1.09,1.19,1.19,0,0,0-1.22,1.09Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.63,132.53v2.6h-.9v-2.35a.93.93,0,0,0-1-1,1.18,1.18,0,0,0-1.19,1.14v2.22h-.9V131h.9v.8a1.58,1.58,0,0,1,1.54-.83A1.46,1.46,0,0,1,234.63,132.53Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,134.86a2,2,0,0,1-1,.3A1.1,1.1,0,0,1,235.8,134v-2.17h-.59v-.67h.59V130h.89v1.14h1.24v.67h-1.24v2c0,.44.17.57.45.57a1.45,1.45,0,0,0,.63-.18Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.42,130.47v1.58h2.5v.82h-2.5v2.26h-.92v-5.49h3.68v.83Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.53,135.13h-.9v-.82a1.54,1.54,0,0,1-1.49.85,1.45,1.45,0,0,1-1.53-1.61V131h.9v2.35a.92.92,0,0,0,1,1,1.18,1.18,0,0,0,1.14-1.3V131h.9Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.65,132.53v2.6h-.9v-2.35a.92.92,0,0,0-1-1,1.18,1.18,0,0,0-1.19,1.14v2.22h-.9V131h.9v.8a1.59,1.59,0,0,1,1.54-.83A1.46,1.46,0,0,1,253.65,132.53Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.63,135.13h-.9v-.72a1.61,1.61,0,0,1-1.47.75,2.13,2.13,0,0,1,0-4.25,1.67,1.67,0,0,1,1.48.76v-2.36h.9Zm-.9-2.07a1.28,1.28,0,1,0-2.56,0,1.28,1.28,0,1,0,2.56,0Z",
    fill: "#164194"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 391.64,
    y: 33.81,
    width: 67.51,
    height: 45,
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "423.96 43.61 425.39 42.57 426.81 43.61 426.27 41.93 427.72 40.89 425.93 40.89 425.39 39.19 424.84 40.9 423.06 40.89 424.5 41.93 423.96 43.61",
    fill: "#ffed00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.62 46.58 412.07 48.28 410.29 48.28 411.74 49.32 411.2 51 412.62 49.96 414.05 51 413.5 49.32 414.95 48.28 413.17 48.28 412.62 46.58",
    fill: "#ffed00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.59 45.59 418.02 44.55 419.44 45.59 418.9 43.91 420.34 42.87 418.56 42.87 418.01 41.17 417.47 42.88 415.69 42.87 417.13 43.91 416.59 45.59",
    fill: "#ffed00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.64 57.32 412.07 58.36 411.52 56.68 412.97 55.64 411.19 55.64 410.64 53.94 410.1 55.65 408.31 55.64 409.76 56.68 409.22 58.36 410.64 57.32",
    fill: "#ffed00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.17 63.02 412.62 61.32 412.08 63.03 410.29 63.02 411.74 64.07 411.2 65.75 412.62 64.7 414.05 65.75 413.5 64.07 414.95 63.02 413.17 63.02",
    fill: "#ffed00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.57 68.43 418.02 66.73 417.48 68.43 415.7 68.43 417.14 69.47 416.6 71.15 418.03 70.11 419.45 71.15 418.91 69.47 420.36 68.43 418.57 68.43",
    fill: "#ffed00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.94 70.39 425.39 68.68 424.84 70.39 423.06 70.39 424.5 71.43 423.97 73.11 425.39 72.07 426.81 73.11 426.27 71.43 427.72 70.39 425.94 70.39",
    fill: "#ffed00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.3 68.43 432.75 66.73 432.21 68.43 430.42 68.43 431.87 69.47 431.33 71.15 432.75 70.11 434.18 71.15 433.63 69.47 435.08 68.43 433.3 68.43",
    fill: "#ffed00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.7 63.02 438.16 61.32 437.61 63.03 435.83 63.02 437.27 64.07 436.73 65.75 438.16 64.7 439.58 65.75 439.04 64.07 440.49 63.02 438.7 63.02",
    fill: "#ffed00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.44 55.62 440.66 55.62 440.11 53.92 439.57 55.62 437.79 55.62 439.23 56.66 438.69 58.34 440.11 57.3 441.54 58.34 441 56.66 442.44 55.62",
    fill: "#ffed00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.73 50.98 438.16 49.94 439.58 50.98 439.04 49.3 440.49 48.26 438.7 48.26 438.16 46.56 437.61 48.26 435.83 48.26 437.27 49.3 436.73 50.98",
    fill: "#ffed00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.77 41.17 432.23 42.88 430.44 42.87 431.89 43.91 431.35 45.59 432.77 44.55 434.2 45.59 433.66 43.91 435.1 42.87 433.32 42.87 432.77 41.17",
    fill: "#ffed00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "391.64 89.14 391.64 83.75 395.55 83.75 395.55 84.38 392.36 84.38 392.36 86.04 395.35 86.04 395.35 86.67 392.36 86.67 392.36 88.51 395.67 88.51 395.67 89.14 391.64 89.14",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.2,83.75h.72v3.12a3.51,3.51,0,0,1-.19,1.29,1.55,1.55,0,0,1-.66.78,2.35,2.35,0,0,1-1.26.3,2.62,2.62,0,0,1-1.24-.26,1.46,1.46,0,0,1-.69-.76,3.53,3.53,0,0,1-.21-1.35V83.75h.72v3.11a3,3,0,0,0,.13,1,.93.93,0,0,0,.45.51,1.54,1.54,0,0,0,.77.18,1.49,1.49,0,0,0,1.13-.36,2.05,2.05,0,0,0,.33-1.37Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.12,89.15v-5.4h2.39a3.41,3.41,0,0,1,1.1.14,1.21,1.21,0,0,1,.6.52,1.5,1.5,0,0,1,.23.81,1.36,1.36,0,0,1-.38,1,1.89,1.89,0,0,1-1.14.5,2,2,0,0,1,.43.27,4.06,4.06,0,0,1,.59.72l.94,1.47H406L405.26,88c-.2-.32-.38-.57-.51-.74a1.73,1.73,0,0,0-.37-.36,1,1,0,0,0-.32-.15l-.4,0h-.83v2.4Zm.71-3h1.54a2.32,2.32,0,0,0,.77-.1.8.8,0,0,0,.41-.33.83.83,0,0,0,.15-.48.79.79,0,0,0-.28-.63,1.32,1.32,0,0,0-.88-.25h-1.71Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.34,86.52a3,3,0,0,1,.72-2.11,2.44,2.44,0,0,1,1.86-.76,2.57,2.57,0,0,1,1.35.36,2.38,2.38,0,0,1,.92,1,3.25,3.25,0,0,1,.31,1.45,3.18,3.18,0,0,1-.33,1.47,2.23,2.23,0,0,1-.94,1,2.61,2.61,0,0,1-1.31.34,2.5,2.5,0,0,1-1.36-.37,2.34,2.34,0,0,1-.91-1,3,3,0,0,1-.31-1.34m.73,0a2.14,2.14,0,0,0,.53,1.53,1.81,1.81,0,0,0,2.64,0,2.29,2.29,0,0,0,.52-1.61,2.74,2.74,0,0,0-.22-1.15,1.73,1.73,0,0,0-.65-.76,1.78,1.78,0,0,0-1-.27,1.83,1.83,0,0,0-1.31.52,2.32,2.32,0,0,0-.55,1.74",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.42,89.14V83.75h2a4.38,4.38,0,0,1,.82,0,1.67,1.67,0,0,1,.67.25,1.31,1.31,0,0,1,.43.52,1.64,1.64,0,0,1,.16.74,1.6,1.6,0,0,1-.44,1.16,2.09,2.09,0,0,1-1.58.48h-1.38v2.19Zm.72-2.83h1.39a1.53,1.53,0,0,0,1-.25,1,1,0,0,0,.29-.73,1,1,0,0,0-.17-.58.83.83,0,0,0-.46-.32,3.09,3.09,0,0,0-.66-.05h-1.38Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.47 89.14 418.47 83.75 422.37 83.75 422.37 84.38 419.18 84.38 419.18 86.04 422.17 86.04 422.17 86.67 419.18 86.67 419.18 88.51 422.5 88.51 422.5 89.14 418.47 89.14",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.89,89.15l2.07-5.4h.77l2.21,5.4h-.81l-.63-1.64h-2.26l-.59,1.64Zm1.56-2.22h1.83l-.56-1.5c-.18-.45-.3-.82-.39-1.12a6.73,6.73,0,0,1-.29,1Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.51 89.14 428.51 83.75 429.24 83.75 432.08 87.99 432.08 83.75 432.76 83.75 432.76 89.14 432.03 89.14 429.19 84.9 429.19 89.14 428.51 89.14",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.6,83.75h.71v3.12a3.77,3.77,0,0,1-.18,1.29,1.53,1.53,0,0,1-.67.78,2.35,2.35,0,0,1-1.26.3A2.65,2.65,0,0,1,437,89a1.54,1.54,0,0,1-.69-.76,3.77,3.77,0,0,1-.2-1.35V83.75h.71v3.11a3,3,0,0,0,.13,1,1,1,0,0,0,.45.51,1.55,1.55,0,0,0,.78.18,1.46,1.46,0,0,0,1.12-.36,2,2,0,0,0,.34-1.37Z",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.5 89.14 441.5 83.75 442.23 83.75 445.06 87.99 445.06 83.75 445.75 83.75 445.75 89.14 445.02 89.14 442.18 84.9 442.18 89.14 441.5 89.14",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.07,
    y: 83.75,
    width: 0.72,
    height: 5.4,
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.83,86.52a3,3,0,0,1,.72-2.11,2.44,2.44,0,0,1,1.86-.76,2.57,2.57,0,0,1,1.35.36,2.38,2.38,0,0,1,.92,1,3.25,3.25,0,0,1,.31,1.45,3.18,3.18,0,0,1-.33,1.47,2.18,2.18,0,0,1-.94,1,2.59,2.59,0,0,1-1.31.34,2.5,2.5,0,0,1-1.36-.37,2.34,2.34,0,0,1-.91-1,3,3,0,0,1-.31-1.34m.73,0a2.14,2.14,0,0,0,.53,1.53,1.81,1.81,0,0,0,2.64,0,2.29,2.29,0,0,0,.52-1.61A2.74,2.74,0,0,0,453,85.3a1.67,1.67,0,0,0-.65-.76,1.78,1.78,0,0,0-1-.27,1.83,1.83,0,0,0-1.31.52,2.32,2.32,0,0,0-.55,1.74",
    fill: "#164194"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.9 89.14 454.9 83.75 455.64 83.75 458.48 87.99 458.48 83.75 459.16 83.75 459.16 89.14 458.43 89.14 455.59 84.9 455.59 89.14 454.9 89.14",
    fill: "#164194"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.29,36.52c9.47,6,11.9,11.54,11.71,12.82C84,70.07,64.57,68.4,62.7,68c8.79-.08,13.57-8.8,14.57-16.43.08-.67.14-1.37.16-2.09A37.32,37.32,0,0,0,75.29,36.52Z",
    fill: "#a42035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,58.61C82.22,71.25,61,77.93,51.21,60.47c-.05-.1-.17-.09-.17,0C52.74,86.58,82.79,84.7,89.33,58.61Z",
    fill: "#a42035"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.84,66.59l0,0c3-3.26,4.68-7.13,4.55-11.06-.29-8.14-8.07-13.13-16-13.41-6.61-.24-14,3.27-17.79,7.27a19,19,0,0,0-1.29,12,14.56,14.56,0,0,0,.94,2.72C36.33,54.59,46,44.85,56.65,47.28A12.88,12.88,0,0,1,64.84,66.59Z",
    fill: "#fbba00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.78,67.5l.35-.17Z",
    fill: "#fbba00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.85,68v0l.07,0Z",
    fill: "#fbba00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.32,66.59A12.85,12.85,0,0,1,62.7,68c8.79-.08,13.57-8.8,14.57-16.43.08-.67.14-1.37.16-2.09a37.32,37.32,0,0,0-2.14-13,29.71,29.71,0,0,0-10.5-2.85A32,32,0,0,0,52.87,35C74.52,37.14,74,60.66,65.32,66.59Z",
    fill: "#bd1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.87,35c-10.12,3.42-14.5,9.26-16.74,13.29-.12.23-.32.7-.51,1.12,3.84-4,11.18-7.51,17.79-7.27,7.93.28,15.71,5.27,16,13.41.13,3.93-1.6,7.8-4.55,11.06A16.17,16.17,0,0,1,62.7,68a11.86,11.86,0,0,0,1.08-.5l.35-.17c.41-.23.81-.48,1.19-.74C74,60.66,74.52,37.14,52.87,35Z",
    fill: "#006139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.65,47.28a12.88,12.88,0,0,1,8.19,19.31A16.48,16.48,0,0,1,62.7,68l.14,0h0C65.33,68.46,84,69.67,87,49.34c.19-1.28-2.24-6.85-11.71-12.82a29.71,29.71,0,0,0-10.5-2.85A32,32,0,0,0,52.87,35c-10.12,3.42-14.5,9.26-16.74,13.29-.13.25-.36.79-.56,1.23a19,19,0,0,0-1.24,11.91,14.56,14.56,0,0,0,.94,2.72C36.33,54.59,46,44.85,56.65,47.28Z",
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterregEn);
export default __webpack_public_path__ + "static/media/interreg_en.63dc14d67139c5911fa0287f55ffb134.svg";
export { ForwardRef as ReactComponent };